var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory1 = function SvgCategory1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category1_svg__w-full category1_svg__h-full",
    viewBox: "0 0 68 68"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#category1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#727277",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M67.074 19.246H.926v47.802h66.148z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#727277",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M49.683.965H18.329v18.283h31.354zM33.994 61.29V26.254"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#727277",
    d: "M42.574 46.201c-.66-1.06-1.633-1.903-2.93-2.505-.96-.446-2.72-.891-5.256-1.325q-2.275-.398-3.335-.759a7.2 7.2 0 0 1-1.91-.951 4.3 4.3 0 0 1-1.355-1.542c-.347-.638-.51-1.337-.51-2.108 0-1.493.614-2.794 1.83-3.902s2.86-1.662 4.921-1.662q2.935 0 4.759 1.554c1.17 1 1.794 2.12 1.899 3.36h1.899v-4.89H40.71v.603c-1.888-1.71-4.134-2.578-6.75-2.578-2.617 0-4.643.735-6.206 2.204s-2.35 3.216-2.35 5.263c0 2.048.682 3.638 2.049 4.746s3.6 1.939 6.703 2.48c2.258.398 3.74.76 4.458 1.085 1.019.457 1.795 1.096 2.316 1.89.52.795.776 1.699.776 2.722 0 1.675-.684 3.108-2.038 4.336-1.355 1.217-3.207 1.831-5.558 1.831s-4.214-.578-5.604-1.746c-1.331-1.12-2.05-2.349-2.177-3.698h-1.887v5.263h1.876v-1.047c1.945 2.12 4.539 3.18 7.792 3.18 2.895 0 5.199-.784 6.9-2.35 1.703-1.565 2.56-3.468 2.56-5.684 0-1.457-.336-2.71-.996-3.782z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "category1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h68v68H0z"
  })))));
};
export default SvgCategory1;